import { render, staticRenderFns } from "./Diensten.vue?vue&type=template&id=245851f4&"
import script from "./Diensten.vue?vue&type=script&lang=js&"
export * from "./Diensten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports